<template>
  <div class="relative">
    <div class="vx-navbar-wrapper nav-menu-wrapper">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColor">

        <router-link tag="div" to="/" class="vx-logo cursor-pointer mr-5 flex items-center">
          <img :src="logo" alt="logo" class="w-10 mr-4" v-if="logo">
          <span class="vx-logo-text">ClassHub</span>
        </router-link>

        <ul class="menu-items flex flex-wrap flex-grow items-center">
          <li
            class  = "menu-item"
            v-for  = "(item, index) in navMenuItems"
            :key   = "index"
            :class = "{'mr-2': !(navMenuItems.length === index+1)}">

            <!-- If header -->
            <template v-if="item.header">
              <h-nav-menu-header :header="item" class="menu-header relative" />
            </template>

            <!-- If it's group -->
            <template v-else-if="item.submenu">
              <h-nav-menu-group
                class="menu-group relative py-4"
                bottom
                :key        ="`group-${index}`"
                :group      ="item"
                :groupIndex ="index"
                :open       ="checkGrpChildrenActive(item)" />
            </template>

            <!-- If it's link -->
            <div v-else-if="item.url" class="menu-link">
              <h-nav-menu-item
                class       = "relative py-4 cursor-pointer"
                :to         = "item.slug !== 'external' ? item.url : null"
                :href       = "item.slug === 'external' ? item.url : null"
                :icon       = "item.icon"
                :target     = "item.target"
                :isDisabled = "item.isDisabled"
                :slug       = "item.slug">
                  <span class="truncate">{{ item.name }}</span>
                  <vs-chip :color="item.tagColor" v-if="item.tag">{{ item.tag }}</vs-chip>
              </h-nav-menu-item>
            </div>

          </li>
        </ul>

<!--        &lt;!&ndash; STARRED PAGES - FIRST 10 &ndash;&gt;-->
<!--        <ul class="vx-navbar__starred-pages">-->
<!--          <draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">-->
<!--            <li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">-->
<!--              <vx-tooltip :text="page.label" position="bottom" delay=".3s">-->
<!--                <feather-icon svgClasses="h-6 w-6" class="p-2 cursor-pointer" :icon="page.labelIcon" @click="$router.push(page.url).catch(() => {})" />-->
<!--              </vx-tooltip>-->
<!--            </li>-->
<!--          </draggable>-->
<!--        </ul>-->

<!--        &lt;!&ndash; STARRED PAGES MORE &ndash;&gt;-->
<!--        <div class="vx-navbar__starred-pages&#45;&#45;more-dropdown" v-if="starredPagesMore.length">-->
<!--          <vs-dropdown vs-custom-content vs-trigger-click>-->
<!--            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>-->
<!--            <vs-dropdown-menu>-->
<!--              <ul class="vx-navbar__starred-pages-more&#45;&#45;list">-->
<!--                <draggable v-model="starredPagesMore" :group="{name: 'pinList'}" class="cursor-move">-->
<!--                  <li class="starred-page&#45;&#45;more flex items-center cursor-pointer" v-for="page in starredPagesMore" :key="page.url" @click="$router.push(page.url).catch(() => {})">-->
<!--                    <feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1" :icon="page.labelIcon"></feather-icon>-->
<!--                    <span class="px-2 pt-2 pb-1">{{ page.label }}</span>-->
<!--                  </li>-->
<!--                </draggable>-->
<!--              </ul>-->
<!--            </vs-dropdown-menu>-->
<!--          </vs-dropdown>-->
<!--        </div>-->

<!--        <div class="bookmark-container">-->
<!--          <feather-icon icon="StarIcon" svgClasses="stoke-current text-warning" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" />-->
<!--          <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">-->
<!--            <vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected" @actionClicked="actionClicked" inputClassses="w-full" show-action show-pinned background-overlay></vx-auto-suggest>-->
<!--          </div>-->
<!--        </div>-->

          <!-- SEARCHBAR -->
          <div class="search-full-container w-full h-full absolute right-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
            <vx-auto-suggest
              class="w-full"
              inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
              :autoFocus="showFullSearch"
              :data="navbarSearchAndPinList"
              icon="SearchIcon"
              placeholder="Search..."
              ref="navbarSearch"
              @closeSearchbar="showFullSearch = false"
              @selected="selected"
              background-overlay />
            <div class="absolute right-0 h-full z-50">
              <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" @click="showFullSearch = false"></feather-icon>
            </div>
          </div>
          <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search mr-4"></feather-icon>

          <!-- NOTIFICATIONS -->
        <Notifications></Notifications>

          <!-- USER META -->
          <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">
            <div class="text-left leading-tight hidden sm:block">
              <p class="font-bold">{{ user.name }}</p>
            </div>
            <vs-dropdown vs-custom-content vs-trigger-click vs-drop-right class="cursor-pointer ml-3">
              <div class="con-img ">
                <img
                  v-if="activeUserImg"
                  key="onlineImg"
                  :src="activeUserImg"
                  alt="user-img"
                  width="40"
                  height="40"
                  class="rounded-full shadow-md cursor-pointer block" />
              </div>
              <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul>
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    @click="$router.push('/pages/profile').catch(() => {})">

                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">الصفحة الشخصية</span>
                  </li>

                  <vs-divider class="m-1"></vs-divider>

                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    @click="logout">
                    <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
                    <span class="ml-2">تسجيل الخروج</span>
                  </li>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import HNavMenuGroup  from "./HorizontalNavMenuGroup.vue"
import HNavMenuHeader from "./HorizontalNavMenuHeader.vue"
import HNavMenuItem   from "./HorizontalNavMenuItem.vue"
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'
import Notifications from '@/views/components/Notifications'

export default {

  props: {
    // navbarColor  : { type: String, default: "#fff", },
      navMenuItems : { type: Array,  required: true   },
      logo: { type: String },
      navbarType: {
          type: String,
          required: true
      }

  },

    data () {
        return {
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            searchQuery: '',
            showFullSearch: false,
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            autoFocusSearch: false,
            showBookmarkPagesDropdown: false,
        }
    },
    watch: {
        '$route'() {
            if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
        }
    },
  components: {
    HNavMenuGroup,
    HNavMenuHeader,
    HNavMenuItem,
    Notifications,
      VxAutoSuggest,
      VuePerfectScrollbar,
      draggable
  },
  computed: {
    navbarColor() {
      return this.$store.state.theme === "dark" ? "#10163a" : "#fff"
    },

    isThemedark() {
        return this.$store.state.theme;
    },
    navbarStyle() {
        let style = {}

        if(this.navbarType === "static") {
            style.transition = "all .25s ease-in-out"

            // if(this.scrollY < 50) {
            //   style.background = "#262c49"
            // }
        }

        return style
    },
    navbarClasses() {
        return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none"
    },
    scrollY() {
        return this.$store.state.scrollY
    },

    // HELPER
    verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
    },
    windowWidth() {
        return this.$store.state.windowWidth
    },

    // BOOKMARK & SEARCH
    data() {
        return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
        return this.$store.state.starredPages;
    },
    starredPagesLimited: {
        get() {
            return this.starredPages.slice(0, 10);
        },
        set(list) {
            this.$store.dispatch('arrangeStarredPagesLimited', list);
        }
    },
    starredPagesMore: {
        get() {
            return this.starredPages.slice(10);
        },
        set(list) {
            this.$store.dispatch('arrangeStarredPagesMore', list);
        }
    },

    // PROFILE
    activeUserInfo() {
        return this.$store.state.AppActiveUser
    },
    user_displayName() {
        return this.activeUserInfo.displayName
    },
    activeUserImg() {
        return this.$store.getters['auth/user'].image
    }
  },
  methods: {
      logout() {
          this.$store.dispatch('auth/logout', this.axios)
              .then((result) => {
                  if(result.data.message === 'success') {
                      this.$store.dispatch(`courses/empty_courses`)
                      this.$router.push('/login')
                  }
              })
      },
      selected(item) {
          this.$router.push(item.url).catch(() => {})
          this.showFullSearch = false;
      },
      actionClicked(item) {
          // e.stopPropogation();
          this.$store.dispatch('updateStarredPage', { index: item.index, val: !item.highlightAction });
      },
      showNavbarSearch() {
          this.showFullSearch = true;
      },
      showSearchbar() {
          this.showFullSearch = true;
      },
      elapsedTime(startTime) {
          let x = new Date(startTime);
          let now = new Date();
          var timeDiff = now - x;
          timeDiff /= 1000;

          var seconds = Math.round(timeDiff);
          timeDiff = Math.floor(timeDiff / 60);

          var minutes = Math.round(timeDiff % 60);
          timeDiff = Math.floor(timeDiff / 60);

          var hours = Math.round(timeDiff % 24);
          timeDiff = Math.floor(timeDiff / 24);

          var days = Math.round(timeDiff % 365);
          timeDiff = Math.floor(timeDiff / 365);

          var years = timeDiff;

          if (years > 0) {
              return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
          } else if (days > 0) {
              return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
          } else if (hours > 0) {
              return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
          } else if (minutes > 0) {
              return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
          } else if (seconds > 0) {
              return seconds + (seconds > 1 ? ' sec ago' : 'just now');
          }

          return 'Just Now'
      },
      outside: function() {
          this.showBookmarkPagesDropdown = false
      },

      // Method for creating dummy notification time
      randomDate({hr, min, sec}) {
          let date = new Date()

          if(hr) date.setHours(date.getHours() - hr)
          if(min) date.setMinutes(date.getMinutes() - min)
          if(sec) date.setSeconds(date.getSeconds() - sec)

          return date
      },
    checkGrpChildrenActive(group) {
      const path        = this.$route.fullPath
      let active        = false
      const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

      if (group.submenu) {
        group.submenu.forEach((item) => {
          if (active) return true
          if ((path == item.url || routeParent == item.slug) && item.url) { active = true }
          else if (item.submenu) { this.checkGrpChildrenActive(item) }
        })
      }

      return active
    },
  },
    directives: {
        'click-outside': {
            bind: function(el, binding) {
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                document.addEventListener('click', handler)
            },

            unbind: function(el) {
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenu.scss"
</style>
